export default __webpack_public_path__ + "static/media/service-output.f64136bd.jpg";